import React from "react";
import LogoutHeader from '../../components/Headers/LogoutHeader';
import LogoutFooter from '../../components/Footers/LogoutFooter';
import RecoverPassword from '../../components/RecoverPassword';
import { Col, Row, Container } from 'react-bootstrap';

const RecoverPasswordPage = () => {
  return (
    <>  
      <LogoutHeader />
      <main className="section-spaces">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <RecoverPassword />
            </Col>
          </Row>
        </Container> 
      </main>
      <LogoutFooter />
    </>
  );
}

export default RecoverPasswordPage;